var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.active && _vm.currentLocation != null
          ? _c(
              "div",
              { staticClass: "row", attrs: { id: "location-buttons" } },
              [
                _c(
                  "div",
                  { staticClass: "panel-toggler" },
                  [
                    [
                      _c(
                        "ul",
                        {
                          staticClass:
                            "list-group list-group-horizontal border-top-0"
                        },
                        [
                          _c(
                            "li",
                            {
                              staticClass:
                                "list-group-item list-group-item-action btn text-center",
                              on: {
                                click: function($event) {
                                  _vm.cancelLocation()
                                }
                              }
                            },
                            [_vm._v("重新選擇地區")]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass:
                                "list-group-item list-group-item-action btn text-center",
                              on: {
                                click: function($event) {
                                  _vm.active = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "查看" +
                                  _vm._s(_vm.currentLocation.name) +
                                  "資料庫"
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: { active: _vm.panelOpened }, attrs: { id: "analysis-app" } },
        [
          _c("div", [
            _vm.active && _vm.currentLocation != null
              ? _c(
                  "ul",
                  {
                    staticClass:
                      "list-group list-group-horizontal border-top-0 panel-toggler"
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "list-group-item list-group-item-action btn text-center",
                        on: {
                          click: function($event) {
                            _vm.cancelLocation()
                          }
                        }
                      },
                      [_vm._v("重新選擇地區")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "list-group-item list-group-item-action btn text-center",
                        on: {
                          click: function($event) {
                            _vm.active = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          "縮小" + _vm._s(_vm.currentLocation.name) + "資料庫"
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "px-3 py-0", attrs: { id: "analysis-panel" } },
              [
                _c(
                  "nav",
                  { staticClass: "tab-buttons px-2 row d-none d-lg-flex" },
                  [
                    _c(
                      "div",
                      {
                        class: [
                          "tab-button dashboard col",
                          { active: _vm.currentTab === "儀表板" }
                        ],
                        on: {
                          click: function($event) {
                            _vm.changeTab("儀表板")
                          }
                        }
                      },
                      [
                        _vm.currentTab === "儀表板"
                          ? _c("img", {
                              class: [
                                "tab-image mb-1",
                                { active: _vm.currentTab === "儀表板" }
                              ],
                              attrs: { src: _vm.tabImages["dashboard-chosen"] }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentTab !== "儀表板"
                          ? _c("img", {
                              class: [
                                "tab-image mb-1",
                                { active: _vm.currentTab === "儀表板" }
                              ],
                              attrs: { src: _vm.tabImages["dashboard-normal"] }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "tab-zh text-truncate" }, [
                          _vm._v("儀表板")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tab-en text-truncate" }, [
                          _vm._v("Dashboard")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.tabs, function(tab) {
                      return _c(
                        "div",
                        {
                          key: tab,
                          class: [
                            "tab-button col",
                            { active: _vm.currentTab === tab }
                          ],
                          on: {
                            click: function($event) {
                              _vm.changeTab(tab)
                            }
                          }
                        },
                        [
                          _c("img", {
                            class: [
                              "tab-image mb-1",
                              { active: _vm.currentTab === tab }
                            ],
                            attrs: {
                              src: _vm.tabImages[_vm.tabImageMapping[tab]]
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tab-zh text-truncate" }, [
                            _vm._v(_vm._s(tab))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tab-en text-truncate" }, [
                            _vm._v(_vm._s(_vm.tabEn[tab]))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row my-3 mx-1 d-lg-none" }, [
                  _c("div", { staticClass: "col-2 pl-0" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentTab != "儀表板",
                            expression: "currentTab != '儀表板'"
                          }
                        ],
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            _vm.changeTab("儀表板")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "48px" },
                          attrs: {
                            src: require("../../assets/images/arrow-left.svg"),
                            title: "儀表板"
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8" }, [
                    _c(
                      "div",
                      { staticClass: "h4 font-weight-bold text-center py-2" },
                      [_vm._v(_vm._s(_vm.currentTab))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2" })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { id: "panel-content" } },
                  [
                    _c("Dashboard", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab == "儀表板",
                          expression: "currentTab == '儀表板'"
                        }
                      ],
                      attrs: {
                        categs: _vm.categs,
                        countyList: _vm.countyList,
                        townList: _vm.townList,
                        location: _vm.currentLocation,
                        tabImages: _vm.tabImages
                      },
                      on: { changeTab: _vm.changeTab }
                    }),
                    _vm._v(" "),
                    _vm.currentTab != "儀表板"
                      ? _c("AnalysisCategs", {
                          attrs: {
                            countyList: _vm.countyList,
                            townList: _vm.townList,
                            location: _vm.currentLocation,
                            currentTab: _vm.currentTab,
                            categ: _vm.currentCateg,
                            indexCompare: _vm.indexCompare
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title row text-center py-3" }, [
      _c(
        "h2",
        {
          staticClass: "col font-weight-bold",
          attrs: { id: "analysis-title-h1" }
        },
        [_vm._v("選擇你要的地區")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }